export default __webpack_public_path__ + "static/media/SEC2710.34I-42207_-25374_0.c9e04105.jpg";